import { createApp } from "vue";
import VueTailwindDatepicker from "vue-tailwind-datepicker";
import defaultAdminRouter from "@/router";
import defaultAdminApp from "@/App.vue";
import defaultAdminStore from "@/store";
import "@/assets/css/reset.css";
import "@/assets/css/tailwind.css";
import "ckeditor5/ckeditor5-content.css";
import tracker from "@/plugins/openReplay";

const router = defaultAdminRouter;
const App = defaultAdminApp;
const store = defaultAdminStore;

const app = createApp(App).use(router).use(store).use(VueTailwindDatepicker);

app.config.globalProperties.$openReplay = tracker;
tracker.start();

app.mount("#app");
